import React, { useRef } from 'react';
import { Loader2, ScanLine, ListChecks, Home } from 'lucide-react';

// Box under the filters with a short explanation + "IMPORTA SELEZIONE" / "LA MIA SELEZIONE" button.
export const MySelectionButton = ({ hasSelection, active, importing, onToggle, onFile, onRequireLogin }) => {
  const inputRef = useRef(null);
  const click = () => {
    if (onRequireLogin) { onRequireLogin(); return; }
    if (hasSelection) onToggle();
    else inputRef.current?.click();
  };
  return (
    <div
      className="mb-4 flex items-center gap-3 rounded-2xl border border-[#F5A623]/30 bg-[#F5A623]/[0.06] pl-3 pr-2 py-2"
      data-testid="my-selection-box"
    >
      <p className="flex-1 text-[12px] leading-snug text-gray-300" data-testid="my-selection-hint">
        {hasSelection
          ? 'Selezione attiva: seguila live'
          : 'Carica lo screenshot e seguila live'}
      </p>
      <button
        onClick={click}
        disabled={importing}
        className={`flex-shrink-0 px-3 py-1.5 rounded-full text-[10.5px] font-black uppercase tracking-wider flex items-center gap-1.5 transition-transform active:scale-95 ${active
          ? 'bg-[#F5A623] text-[#1A1A1A] shadow-[0_0_16px_rgba(245,166,35,0.75)]'
          : 'bg-gradient-to-r from-[#F5A623] to-[#FF8A3D] text-[#1A1A1A] shadow-[0_0_14px_rgba(245,166,35,0.6)] animate-[pulse_2.5s_ease-in-out_infinite]'}`}
        data-testid="my-selection-btn"
      >
        {importing ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : hasSelection && active ? <Home className="w-3.5 h-3.5" /> : hasSelection ? <ListChecks className="w-3.5 h-3.5" /> : <ScanLine className="w-3.5 h-3.5" />}
        {importing ? 'Analizzo…' : hasSelection && active ? 'Home' : hasSelection ? 'La mia selezione' : 'Importa selezione'}
      </button>
      <input
        ref={inputRef}
        type="file"
        accept="image/png,image/jpeg,image/webp"
        className="hidden"
        onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ''; onFile(f); }}
        data-testid="my-selection-file-input"
      />
    </div>
  );
};

export default MySelectionButton;
